import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_INT_CSC_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/cla/calendario-lancamento-contabil`;

export default{
    async listar(){
        return await Vue.prototype.$httpJson.get(baseUrl);
    },
    async inserir(model){
        return await Vue.prototype.$httpJson.post(baseUrl, model);
    },
    async inserirLog(model){
        return await Vue.prototype.$httpJson.post(`${baseUrl}-log`, model);
    }
}